import React from 'react';
import { StyledActionBar, StyledButtonContainer, StyledTextContainer } from './ActionBar.styles';
export function ActionBar({ table, isFixed, TableActions }) {
    const selectedItems = table.getRowModel().rows.filter((row) => row.getIsSelected());
    const unselectRows = () => {
        table.getRowModel().rows.forEach((row) => {
            row.toggleSelected(false);
        });
    };
    return (React.createElement(StyledActionBar, { isFixed: isFixed },
        React.createElement(StyledTextContainer, null,
            React.createElement("span", null,
                selectedItems.length,
                " ",
                selectedItems.length > 1 ? 'items' : 'item',
                " selected")),
        React.createElement(StyledButtonContainer, null, TableActions && React.createElement(TableActions, { selectedItems: selectedItems, unselectRows: unselectRows }))));
}
//# sourceMappingURL=ActionBar.js.map